import fetch from 'node-fetch';

const QueryCluster = (clusterId: string): Promise<any> =>
  fetch(`${process.env.REACT_APP_SERVER}/clusters/${clusterId}`);

export { QueryCluster };
